import React from "react";
import styles from "./FullPageDivider.module.scss";

interface FullPageDividerProps {
  className?: string;
}

const FullPageDivider = ({ className = "" }: FullPageDividerProps) => {
  return (
    <hr
      className={`${styles.fullPageDivider} ${className}`}
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + "/images/decors/solvize-full-page-divider.svg"
        })`,
      }}
    />
  );
};

export default FullPageDivider;
